<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-for="(property, index) in properties" :key="property._key">
        <label :for="safeId(property._key)" class="col-sm-4 col-form-label">{{ property.label }}</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId(property._key)"
                 v-model.lazy="data[property._key]"
                 @change="updateProperty(property._key)">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapTemplateData, mapTemplateOptions } from '../../utils'
import * as action from '../../store/action-types'

export default {
  name: 'loopic-template',
  mixins: [templateMixin],
  computed: {
    ...mapTemplateData({data: {default: {}}}),
    ...mapTemplateOptions(['schema']),
    properties () {
      return Object.keys(this.schema.properties).map(key => ({
        _key: key,
        label: this.schema.properties[key].label,
        type: this.schema.properties[key].type,
        description: this.schema.properties[key].description,
        default: this.schema.properties[key].default,
        gddType: this.schema.properties[key].gddType
      }))
    }
  },
  watch: {},
  methods: {
    updateProperty (key) {
      this.$store.dispatch(action.TEMPLATE_DATA, {
        templateId: this.templateId,
        data: {data: this.data}
      })
      this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
        templateId: this.templateId,
        data: this.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/loopic-template.vue